import React, {useEffect, useState} from 'react'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const GET_SEMESTERS_URL = `${API_URL}/Custom/GetSemesters`
const GET_GRADE_LEVELS_URL = `${API_URL}/Custom/GetMyDepartmentClasses`
const GET_SCHEDULE_BY_GRADE_URL = `${API_URL}/Custom/GetDepartmentWeeklyScheduleByClass`

interface Option {
  id: number
  name: string
}

interface ScheduleItem {
  id: number
  day: number
  startTime: string
  endTime: string
  courseName: string
  courseCode?: string
  classroomName: string
  name?: string
  detail?: string
}

const dayNames = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar']

const dayColors = [
  'bg-primary',
  'bg-secondary',
  'bg-success',
  'bg-danger',
  'bg-warning',
  'bg-info',
  'bg-dark',
]

const DepartmentCourseScheduleList: React.FC = () => {
  const [semesters, setSemesters] = useState<Option[]>([])
  const [selectedSemester, setSelectedSemester] = useState<number | null>(null)
  const [gradeLevels, setGradeLevels] = useState<Option[]>([])
  const [selectedGradeLevel, setSelectedGradeLevel] = useState<number | null>(null)
  const [schedule, setSchedule] = useState<ScheduleItem[]>([])

  useEffect(() => {
    axios
      .get(GET_SEMESTERS_URL)
      .then((res) => setSemesters(res.data || []))
      .catch(console.error)
  }, [])

  useEffect(() => {
    if (!selectedSemester) return
    axios
      .get(`${GET_GRADE_LEVELS_URL}?semesterId=${selectedSemester}`)
      .then((res) => setGradeLevels(res.data || []))
      .catch(console.error)
  }, [selectedSemester])

  const loadSchedule = () => {
    if (!selectedSemester || !selectedGradeLevel) return
    axios
      .get(`${GET_SCHEDULE_BY_GRADE_URL}?semesterId=${selectedSemester}&classId=${selectedGradeLevel}`)
      .then((res) => setSchedule(res.data || []))
      .catch(console.error)
  }

  const renderTable = () => {
    if (!schedule.length) return null
    const grouped = schedule.reduce((acc: Record<number, ScheduleItem[]>, item) => {
      if (!acc[item.day]) acc[item.day] = []
      acc[item.day].push(item)
      return acc
    }, {})
    return (
      <div className='row'>
        {Object.entries(grouped).map(([day, items]) => (
          <div key={day} className='col-md-6 col-lg-4 mb-4'>
            <h5
              className={`p-2 rounded text-center text-white ${dayColors[Number(day) - 1]}`}
            >
              {dayNames[Number(day) - 1]}
            </h5>
            <table className='table table-bordered table-hover'>
              <thead className='table-light'>
                <tr>
                  <th className='text-center'>Saat</th>
                  <th>Ders</th>
                  <th>Tür</th>
                  <th>Sınıf</th>
                  <th>Açıklama</th>
                </tr>
              </thead>
              <tbody>
                {items.map((i) => (
                  <tr key={i.id}>
                    <td className='text-center'>
                      <span className='badge bg-info text-dark'>
                        {i.startTime} - {i.endTime}
                      </span>
                    </td>
                    <td>{i.courseCode ? `${i.courseName} (${i.courseCode})` : i.courseName}</td>
                    <td>{i.name ? i.name.split(' - ').pop() : ''}</td>
                    <td>{i.classroomName}</td>
                    <td>{i.detail || ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className='container mt-4'>
      <h2 className='mb-4'>Bölüm Haftalık Ders Programı</h2>
      <div className='mb-3'>
        <label>Dönem</label>
        <select
          className='form-control'
          value={selectedSemester || ''}
          onChange={(e) => setSelectedSemester(Number(e.target.value))}
        >
          <option value='' disabled>
            Seçiniz
          </option>
          {semesters.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>
      </div>
      <div className='mb-3'>
        <label>Sınıf</label>
        <select
          className='form-control'
          value={selectedGradeLevel || ''}
          onChange={(e) => setSelectedGradeLevel(Number(e.target.value))}
        >
          <option value='' disabled>
            Seçiniz
          </option>
          {gradeLevels.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>
      </div>
      <button className='btn btn-primary mb-4' onClick={loadSchedule}>
        Listele
      </button>
      {renderTable()}
    </div>
  )
}

export default DepartmentCourseScheduleList
